document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

  class ProductTabs {
    constructor(container) {
      this.container = container;
      this.tabs = container.querySelectorAll(".nav-bar-wrap li");
      this.textSections = container.querySelectorAll(".tab_section_wrap");
      this.dots = container.querySelectorAll(".floatingdot_section_wrap");
      // this.imgSections = container.querySelectorAll(".tab_section_wrap_img");
      this.idKey = this.container.dataset.key;

      this.positionMap = {
        1: "41%",
        2: "45%",
        3: "49%",
        4: "53%",
        5: "57%",
      };
      // this.positionDottop = {
      //   1: "17%",
      //   2: "75%",
      //   3: "38%",
      //   4: "15%",
      //   5: "65%",
      // };

      // this.positionDotleft = {
      //   1: "63%",
      //   2: "26%",
      //   3: "75%",
      //   4: "30%",
      //   5: "82%",
      // };

      this.init();
    }

    init() {
      this.setInitialPosition();
      this.attachClickHandlers();
      this.setupScrollTrigger();
      this.handleRotateBtn();
      setTimeout(() => {
        if (window.innerWidth < 1150) {
          this.activateTab(this.idKey + "1");
        }
      }, 200);
    }

    setInitialPosition() {
      gsap.set(this.textSections, { top: "41%" });
      // gsap.set(this.imgSections, { top: "41%" });
      // gsap.set(this.dots, { top: "17%", left:"63%" });
    }

    attachClickHandlers() {
      this.tabs.forEach((tab) => {
        tab.addEventListener("click", () => {
          this.activateTab(tab.dataset.controlls);
        });
      });
      this.dots.forEach((dot) => {
        dot.addEventListener("click", () => {
          this.activateTab(dot.dataset.controlls);
        });
      });
    }

    activateTab(id) {
      this.tabs.forEach((t) => t.classList.remove("active"));
      this.dots.forEach((d) => d.classList.remove("active"));
      this.textSections.forEach((d) => d.classList.remove("active"));
      
      const tab = this.container.querySelector(`[data-controlls="${id}"]`);
      if (tab) tab.classList.add("active");
      
      const img = this.container.querySelector(`.tab_section_wrap [data-target="${id}"]`);
      if (img) img.classList.add("active");

      const dot = this.container.querySelector(`.floatingdot_section_wrap[data-target="${id}"]`);
      if (dot) dot.classList.add("active");

      let index = id.replace(this.idKey, "");
      const topValue = this.positionMap[index];
      // const dottopValue = this.positionDottop[index];
      // const dotleftValue = this.positionDotleft[index];

      gsap.to(this.textSections, {
        top: topValue,
        duration: 0.3,
        ease: "power2.out",
        onComplete: () => {
          this.textSections.forEach((section) => {
            if (section.dataset.target === id) {
              gsap.fromTo(section, { opacity: 0 }, { opacity: 1, duration: 0 });
              section.style.display = "block";
            } else {
              gsap.fromTo(section, { opacity: 0 }, { opacity: 1, duration: 0 });
              section.style.display = "none";
            }
          });

        },
      });
      // gsap.to(this.dots, {
      //   top: dottopValue,
      //   left:dotleftValue,
      //   duration: 0.6,
      //   ease: "power2.out",
      //   // onComplete: () => {
      //   //   this.textSections.forEach((section) => {
      //   //     if (section.dataset.target === id) {
      //   //       gsap.fromTo(section, { opacity: 0 }, { opacity: 1, duration: 0 });
      //   //       section.style.display = "block";
      //   //     } else {
      //   //       gsap.fromTo(section, { opacity: 0 }, { opacity: 1, duration: 0 });
      //   //       section.style.display = "none";
      //   //     }
      //   //   });

      //   // },
      // });
    }

    setupScrollTrigger() {
       if (window.innerWidth < 1150) return;
      ScrollTrigger.create({
        trigger: this.container.querySelector(".product-tab-wraper"),
        start: "top 0",
        // end: "bottom center",
        // end: "bottom top+=1000",
         end: "+=2000", // was probably shorter before
        pin: this.container.querySelector(".product-tab-wraper"),
        scrub: true,
        onUpdate: (self) => {
          const progress = self.progress;
          let activeIndex = 1;

          if (progress < 0.2) activeIndex = 1;
          else if (progress < 0.4) activeIndex = 2;
          else if (progress < 0.6) activeIndex = 3;
          else if (progress < 0.8) activeIndex = 4;
          else activeIndex = 5;

          // const activeTab = this.container.querySelector(`#${this.idKey + activeIndex}`);
          const activeTab = this.container.querySelector(`[data-controlls="${this.idKey + activeIndex}"]`);
          if (activeTab && !activeTab.classList.contains("active")) {
            activeTab.click(); // Trigger animation
          }
        },
      });
    }

    handleRotateBtn() {
      const rotateBtn = this.container.querySelector(".rotate_btn_col");

      rotateBtn?.addEventListener("click", () => {
        const sections = this.container.querySelectorAll(".tab_section_wrap_img");
        const current = this.container.querySelector(".tab_section_wrap_img.active-img");

        if (current) {
          current.classList.remove("active-img");

          // Find the index of the current element
          let currentIndex = Array.from(sections).indexOf(current);

          // Calculate next index (loop to start if at end)
          let nextIndex = (currentIndex + 1) % sections.length;

          // Add active class to the next element
          sections[nextIndex].classList.add("active-img");
        }
      });
    }
  }

  // Create instances for all product-tabs-section blocks
  document.querySelectorAll(".product-tabs-section").forEach((section) => {
    new ProductTabs(section);
  });
});

/*
document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

  const tabs = document.querySelectorAll(".nav-bar-wrap li");
  const textSections = document.querySelectorAll(".tab_section_wrap");
  // const imgSections = document.querySelectorAll(".tab_section_wrap_img");

  const positionMap = {
    1: "41%",
    2: "45%",
    3: "49%",
    4: "53%",
    5: "57%",
  };

  function activateTab(id) {
    // Set active nav tab
    tabs.forEach((t) => t.classList.remove("active"));
    const tab = document.getElementById(id);
    tab.classList.add("active");

    // Show all sections for animation
    // textSections.forEach(s => (s.style.display = "block"));
    // imgSections.forEach(s => (s.style.display = "block"));

    const topValue = positionMap[id];

    gsap.to(textSections, {
      top: topValue,
      duration: 0.6,
      ease: "power2.out",
      onComplete: () => {
        textSections.forEach((section) => {
          if (section.dataset.target === id) {
            gsap.fromTo(section, { opacity: 0 }, { opacity: 1, duration: 0.1 });
            section.style.display = "block";
          } else {
            gsap.fromTo(section, { opacity: 0 }, { opacity: 1, duration: 0.1 });
            section.style.display = "none";
          }
        });

        // imgSections.forEach(section => {
        //     if (section.id === `section-${id}`) {
        //         section.style.display = "block";
        //         gsap.fromTo(section, { opacity: 0 }, { opacity: 1, duration: 0 });
        //     } else {
        //         section.style.display = "none";
        //     }
        // });
      },
    });

    // gsap.to(imgSections, {
    //     top: topValue,
    //     duration: 0.3,
    //     ease: "power2.out",
    //     // onComplete: () => {
    //     //     textSections.forEach(section => {
    //     //         section.style.display = section.id === `section-${id}` ? "block" : "none";
    //     //     });
    //     //     imgSections.forEach(section => {
    //     //         section.style.display = section.id === `section-${id}` ? "block" : "none";
    //     //     });
    //     // }
    //     onComplete: () => {
    //         textSections.forEach(section => {
    //             if (section.id === `section-${id}`) {
    //                 section.style.display = "block";
    //                 gsap.fromTo(section, { opacity: 0 }, { opacity: 1, duration: 0.1 });
    //             } else {
    //                 gsap.fromTo(section, { opacity: 0 }, { opacity: 1, duration: 0.1 });
    //                 section.style.display = "none";
    //             }
    //         });

    //         imgSections.forEach(section => {
    //             if (section.id === `section-${id}`) {
    //                 section.style.display = "block";
    //                 gsap.fromTo(section, { opacity: 0 }, { opacity: 1, duration: 0 });
    //             } else {
    //                 section.style.display = "none";
    //             }
    //         });
    //     }

    // });
  }

  // Click events
  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      activateTab(tab.dataset.controlls);
    });
  });

  // Initial view
  activateTab("1");
  gsap.set(textSections, { top: "41%" });
  // gsap.set(imgSections, { top: "41%" });

  // ScrollTrigger sync
  ScrollTrigger.create({
    trigger: ".product-tab-wraper",
    start: "top 0",
    end: "bottom center",
    pin: ".product-tab-wraper",
    scrub: true,
    onUpdate: (self) => {
      const progress = self.progress;
      let activeIndex = 1;

      if (progress < 0.2) activeIndex = 1;
      else if (progress < 0.4) activeIndex = 2;
      else if (progress < 0.6) activeIndex = 3;
      else if (progress < 0.8) activeIndex = 4;
      else activeIndex = 5;

      const activeTab = document.getElementById(activeIndex.toString());
      if (!activeTab.classList.contains("active")) {
        activeTab.click(); // Trigger animation
      }
    },
  });
});
*/
